// Plans Selectors

import get from 'lodash-es/get';
import { API_STATUS, PERSONALIZATION_RULES } from '../../../utilities/constants';
import { ERROR_INVALID_DATE, ERROR_POD, ERROR_POD_DATE } from './utilities/constants';

const getErrorCode = originalCode => {
  if (originalCode == null) return null;

  if (originalCode === ERROR_INVALID_DATE) {
    return { code: originalCode };
  }

  if (originalCode.startsWith(ERROR_POD) && !originalCode.startsWith(ERROR_POD_DATE)) {
    const promoOfTheDay = originalCode.replace(`${ERROR_POD}-`, '');
    return { code: ERROR_POD, promoOfTheDay };
  }

  if (originalCode.startsWith(ERROR_POD_DATE)) {
    const parts = originalCode.split('-');

    const promoOfTheDay = parts[1];
    const endDate = parts[2];
    return { code: ERROR_POD_DATE, promoOfTheDay, endDate: endDate };
  }
};

export const getCalendarRangeRestrictionList = state => {
  return state.selectedSuiteRangeRestrictions;
};

export const getOfferCodeError = state => {
  return state.offerCodeError;
};

export const getIsBookingWidgetFocused = state => {
  return state.isBookingWidgetFocused;
};

/**
 * Returns the filters applied labels.
 * @param {Object} state Plan store.
 * @returns {Object} Filters applied.
 */
export const getFiltersAppliedLabels = state => {
  return state.filtersApplied;
};

/**
 * Returns the old filters applied labels.
 * @param {Object} state Plan store.
 * @returns {Object} Old filters applied.
 */
export const getOldFiltersAppliedLabels = state => {
  return state.oldFiltersApplied;
};

/**
 * Returns the sorting criteria.
 * @param {Object} state Plan store.
 * @returns {string} Actual sorting criteria.
 */
export const getSortOrder = state => {
  return state.sorting;
};

export const getAvailabilityList = state => {
  return state.availabilityList;
};

export const getIsIdMeValidationRequired = state => {
  return state.isIdMeValidationRequired;
};

export const getIsIdMeValidationRequiredWithError = state => {
  return state.isIdMeValidationRequiredWithError;
};

/**
 * Returns the Interactions personalization data from the availability reponse
 * @param {Object} state
 */
export const getInteractionsData = state => {
  const interactions =
    state.personalizationResponses &&
    state.personalizationResponses.filter(pr => pr.rule === PERSONALIZATION_RULES.interactions);

  return interactions && interactions.length > 0 && interactions[0].data;
};

export const getRecentSearchesList = state => {
  return get(state, 'recentSearchesList', []);
};

export const getRecentSearchesIsLoading = state => {
  return state.recentSearchesApiStatus === API_STATUS.LOADING;
};

export const getDeleteRecentSearchesIsLoading = state => {
  return state.deleteRecentSearchesApiStatus === API_STATUS.LOADING;
};

export const getRecentSearchesLoading = state => {
  return getRecentSearchesIsLoading(state) || getDeleteRecentSearchesIsLoading(state);
};

export const getDealsSummary = state => {
  return state.dealsSummary;
};

export const getLowestRateCalendarList = state => {
  return state.lowestRateCalendarList;
};

export const getLowestRatesByStayList = state => {
  return state.lowestRatesByStayList;
};

export const getLastLowestRatesByStayDateSelection = state => {
  return state.lastCalendarRatesDateSelection;
};

export const getIsCartOpenClose = state => {
  return state.isCartOpenClose;
};

export const getCartReturnedPageLinkClicked = state => {
  return state.cartReturnedPageLinkClicked;
};

export const getAvRangeBySuiteIsLoading = state => state?.availabilityRangeBySuiteApiStatus === API_STATUS.LOADING;

export const getAvRangeBySuiteFailed = state => state?.availabilityRangeBySuiteApiStatus === API_STATUS.ERROR;

export const getPromoSearchErrorCode = state => {
  const errors = state.errors;
  if (errors == null || errors?.length <= 0) return null;
  const firstError = errors[0];
  if (firstError && errors[1] != null) return getErrorCode(errors[1]?.code);
  return null;
};

export const getAvailabilityReqIsLoading = state => state.planAvailabilityApiStatus === API_STATUS.LOADING;

export const getUpsellRecommendationData = state => state.upsellRecommendationData;

export const getQualifyingID = state => state.qualifyingID;

export const getRequiresQualifyingID = state => state.requiresQualifyingID;

export const getIsErrorModalAlreadyClosed = state => state.isErrorModalAlreadyClosed;

export const getQualifyingIDError = state => state.qualifyingIDError;

export const getEmailCampaign = state => state.emailCampaign;

export const getSelectedSuiteForCalendar = state => state.selectedSuiteForCalendar;

export const getSortSuite = state => state.sortSuite;

export const getOfferType = state => state.offerType;

export const getAvailabilityErrorMessage = state => state.availabilityErrorMessage;

export const getPromoDescription = state => state.promoDescription;

export const getAvailabilityHighestRatesList = state => state.availabilityHighestRatesList;

export const getSelectedSuiteForRange = state => state.selectedSuiteForRange;

export const getSelectedSuiteRange = state => state.selectedSuiteRange;

export const getAvailabilityHighestRatesRequestFailed = state => state.availabilityHighestRatesRequestFailed;

export const getAvailabilityHighestRatesRequestDatesExceededFailed = state =>
  state.availabilityHighestRatesRequestDatesExceededFailed;

export const getUpsellPackagesContent = state => state.upsellPackagesContent;

export const getSavePointsForLater = state => state.savePointsForLater;

export const getIsChangedToFlex = state => state.isChangedToFlex;

export const getIsProperty = state => state.isProperty;

export const getIsPropertyRestricted = state => Boolean(state.isPropertyRestricted);
